import { useQuery } from "react-query";
import {
  getProjects,
  getProject,
  getProjectHotels,
  getProjectReportCategories,
  getProjectDistinctReportNames,
  getProjectPMSDistinctReportNamesByReportType,
  getProjectReports,
  getProjectSmartScan,
  getProjectHotelPMS,
  getProjectHotelsForPMS,
  getProjectIndexes,
  getProjectHotelsSubHeaderData,
} from "../api/project";

const useGetProjectList = (options = {}) =>
  useQuery("getProjects", getProjects, options);

const useGetProject = (id, options = {}) =>
  useQuery(["getProject", id], () => getProject(id), options);

const useGetProjectHotels = (id, options = {}) =>
  useQuery(["getProjectHotels", id], () => getProjectHotels(id), options);

const useGetProjectReportCategories = (id, options = {}) =>
  useQuery(
    ["getProjectReportCategories", id],
    () => getProjectReportCategories(id),
    options,
  );

const useGetProjectDistinctReportNames = (id, options = {}) =>
  useQuery(
    ["getProjectDistinctReportNames", id],
    () => getProjectDistinctReportNames(id),
    options,
  );

const useGetProjectDistinctReportNamesByReportType = (
  id,
  options = {},
  queryData = {},
) =>
  useQuery(
    [
      "useGetProjectDistinctReportNamesByReportType",
      id,
      ...Object.values(queryData),
    ],
    () => getProjectDistinctReportNames(id, queryData),
    options,
  );

const useGetProjectPMSDistinctReportNamesByReportType = (
  projectId,
  pmsId,
  reportType,
  options = {},
) =>
  useQuery(
    [
      "getProjectPMSDistinctReportNamesByReportType",
      projectId,
      pmsId,
      reportType,
    ],
    () =>
      getProjectPMSDistinctReportNamesByReportType(
        projectId,
        pmsId,
        reportType,
      ),
    options,
  );

const useGetProjectReports = (id, queryData = {}, options = {}) =>
  useQuery(
    ["getProjectReports", id, Object.values(queryData)],
    () => getProjectReports(id, queryData),
    options,
  );

const useGetProjectSmartScan = (id, options = {}) =>
  useQuery(["getProjectSmartScan", id], () => getProjectSmartScan(id), options);

const useGetProjectHotelPMS = (id, options = {}) =>
  useQuery(["getProjectHotelPMS", id], () => getProjectHotelPMS(id), {
    enabled: !!id,
    ...options,
  });

const useGetProjectHotelsForPMS = (projectId, pmsId, options = {}) =>
  useQuery(
    ["getProjectHotelsForPMS", projectId, pmsId],
    () => getProjectHotelsForPMS(projectId, pmsId),
    {
      enabled: !!projectId && !!pmsId,
      ...options,
    },
  );

const useGetProjectIndexes = (id, options = {}) =>
  useQuery(["getProjectIndex", id], () => getProjectIndexes(id), options);
const useGetProjectHotelsSubHeaderData = (projectId, options = {}) =>
  useQuery(
    ["getProjectHotelsSubHeaderData", projectId],
    () => getProjectHotelsSubHeaderData(projectId),
    {
      enabled: !!projectId,
      ...options,
    },
  );

export {
  useGetProjectList,
  useGetProject,
  useGetProjectHotels,
  useGetProjectReportCategories,
  useGetProjectDistinctReportNames,
  useGetProjectDistinctReportNamesByReportType,
  useGetProjectPMSDistinctReportNamesByReportType,
  useGetProjectReports,
  useGetProjectSmartScan,
  useGetProjectHotelPMS,
  useGetProjectHotelsForPMS,
  useGetProjectIndexes,
  useGetProjectHotelsSubHeaderData,
};
